export enum ChainId {
  BSC = 56,
  OPBNB = 204,
}

export const SUPPORTED_CHAINS = [
  ChainId.BSC,
  ChainId.OPBNB
] as const
export type SupportedChainsType = typeof SUPPORTED_CHAINS[number]

export enum NativeCurrencyName {
  // Strings match input for CLI
  BSC = 'BNB',
  OPBNB = 'BNB'
}
